import {
  LAYER_TYPES,
  LAYER_SUBTYPES,
  PROP_DATA_TYPE,
  GEOJSON_GEOMETRIES
} from '../../../../api/Layers/Layers';

export default [
  {
    name: 'GeoJSON VT',
    url:
      'https://raw.githubusercontent.com/codeforamerica/click_that_hood/master/public/data/spain-provinces.geojson',
    layerType: LAYER_TYPES.SPATIAL,
    layerSubType: LAYER_SUBTYPES.GEOJSONVT,
    description: '',
    attribution:
      '<a href="https://openmaptiles.org/">&copy; OpenMapTiles</a>, <a href="https://www.openstreetmap.org/copyright">&copy; OpenStreetMap</a> contributors',
    styleId: 'GeoJSON VT',
    subdomains: '01234',
    geojsonProps: [
      {
        name: 'cod_prov',
        max: '52',
        min: '01',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'name',
        max: 'Ávila',
        min: 'A Coruña',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'cod_ccaa',
        max: '19',
        min: '01',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'cartodb_id',
        max: 52,
        min: 1,
        dataType: PROP_DATA_TYPE.NUMBER
      },
      {
        name: 'created_at',
        max: '2014-09-30T00:00:00Z',
        min: '2014-09-30T00:00:00Z',
        dataType: PROP_DATA_TYPE.STRING
      },
      {
        name: 'updated_at',
        max: '2014-12-25T01:56:10Z',
        min: '2014-12-25T01:56:10Z',
        dataType: PROP_DATA_TYPE.STRING
      }
    ],
    geojsonGeometry: GEOJSON_GEOMETRIES.POLYGON,
    mapLocation: {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.62451171875, 36.61552763134925]
      },
      properties: {
        zoom: 5
      }
    }
  },
  {
    name: 'MapBox',
    url:
      'https://geoserver.ipsilum.com/geoserver/gwc/service/tms/1.0.0/Mapas_tematicos:mv_espmunicipios_suav@EPSG%3A900913@pbf/{z}/{x}/{-y}.pbf',
    layerType: LAYER_TYPES.SPATIAL,
    layerSubType: LAYER_SUBTYPES.MAPBOX,
    mapboxLayerName: 'mv_espmunicipios_suav',
    mapboxProps: [
      { name: 'natcode', max: 34172626181, min: '34091717187', dataType: PROP_DATA_TYPE.NUMBER },
      { name: 'nameunit', max: 'la Romana', min: 'Alía', dataType: PROP_DATA_TYPE.STRING },
      { name: 'ine_code', max: 53062, min: 3114, dataType: PROP_DATA_TYPE.NUMBER },
      {
        name: 'bbox',
        max: '3.099528,42.00260782,3.22850461,42.10885368',
        min: '-0.04030475,38.80488735,-0.01678214,38.82690926',
        dataType: PROP_DATA_TYPE.STRING
      }
    ],
    geojsonGeometry: GEOJSON_GEOMETRIES.POLYGON,
    description: '',
    attribution:
      '<a href="https://openmaptiles.org/">&copy; OpenMapTiles</a>, <a href="https://www.openstreetmap.org/copyright">&copy; OpenStreetMap</a> contributors',
    styleId: 'MapBox',
    subdomains: 'abcd',
    mapLocation: {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-7.62451171875, 36.61552763134925]
      },
      properties: {
        zoom: 5
      }
    }
  }
];
